export default __webpack_public_path__ + "static/media/shonit v6.f71e73a0.mp4";